import routerOptions0 from "/home/runner/work/ott-web-portal2/ott-web-portal2/node_modules/.pnpm/nuxt@4.0.3_@types+node@20.17.30_@vue+compiler-sfc@3.5.20_eslint@9.24.0_rollup@4.49.0_sass@1.8_w2etmzr24wz7alwc6jub3qfyoe/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}